import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReferenceDataLabels } from '../../../../../lib/constants/reference-data-labels';

@Component({
  selector: 'boi-form-information-box',
  templateUrl: './form-information-box.component.html',
  styleUrls: ['./form-information-box.component.scss']
})
export class FormInformationBoxComponent {
  @Input() public decoration: string;
  @Input() public message: string;
  @Input() public buttonLabel: string;
  @Input() public shouldNotLocalize: boolean;
  @Input() public includeOkButton: boolean;
  @Input() public buttonDisabled: boolean;
  @Output() public readonly clickEvent = new EventEmitter<any>();
  @Output() public readonly buttonClickEvent = new EventEmitter<any>();

  referenceDataLabels = ReferenceDataLabels;
  isOkButtonPressed: boolean;
}
